import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Input, Select, Button, Space } from 'antd';
import {
  timeTrackerUserGroupCreateService,
  timeTrackerUserGroupUpdateService,
  timeTrackerUserGroupGetService,
  timeTrackerAssignableUsersListService,
} from 'services/time_tracker';
import { handleApiSuccess, handleApiError } from 'utils';
import { timeTrackerAssignableUserLabel } from 'utils/time_tracker_assignable_user_label';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};
const tailLayout = {
  wrapperCol: { offset: 6, span: 14 },
};

export default function TimeTrackerUserGroupForm(props) {
  const { id } = props;
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const [form] = Form.useForm();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    timeTrackerAssignableUsersListService()
      .then((res) => {
        if (res.data.items && res.data.items.length > 0) {
          setUsers(res.data.items);
        }
      })
      .catch(handleApiError);

    if (id) {
      timeTrackerUserGroupGetService(id)
        .then((res) => {
          if (res.data.items && res.data.items.length > 0) {
            const record = res.data.items[0];
            form.setFieldsValue({
              group_name: record.group_name,
              members: (record.members || []).map((u) => (u._id ? u._id : u)),
            });
          }
        })
        .catch(handleApiError);
    }
  }, [id, form]);

  const onFinish = (values) => {
    setIsLoading(true);
    const payload = {
      group_name: values.group_name,
      members: values.members || [],
    };
    const promise = id
      ? timeTrackerUserGroupUpdateService(id, payload)
      : timeTrackerUserGroupCreateService(payload);
    promise
      .then((response) => {
        setIsLoading(false);
        handleApiSuccess(response);
        history.push('/time-tracker/user-groups');
      })
      .catch((err) => {
        setIsLoading(false);
        handleApiError(err);
      });
  };

  return (
    <Form
      {...layout}
      form={form}
      name="time-tracker-user-group"
      onFinish={onFinish}
    >
      <Form.Item
        name="group_name"
        label="Group name"
        rules={[{ required: true, message: 'Enter a group name' }]}
      >
        <Input placeholder="e.g. Acme rollout team" />
      </Form.Item>
      <Form.Item name="members" label="Members" extra="Includes Super Admin / MSP staff (roles 10–13), even when they are not stored under this reseller’s client.">
        <Select
          mode="multiple"
          placeholder="Select users in this group"
          showSearch
          optionFilterProp="label"
          onKeyDown={(e) => {
            const listId = e.target.getAttribute('aria-controls');
            const { key } = e;
            if (key === 'Tab') {
              const dropdown = document
                .getElementById(listId)
                ?.parentElement?.querySelector('.ant-select-item-option-active');
              if (dropdown) dropdown.click();
            }
          }}
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          dropdownRender={(menu) => (
            <>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '8px 12px',
                  borderBottom: '1px solid #f0f0f0',
                  gap: 12,
                }}
              >
                <span
                  style={{ cursor: 'pointer', color: '#1890ff' }}
                  onClick={() =>
                    form.setFieldsValue({ members: users.map((u) => u._id) })
                  }
                >
                  Select all users
                </span>
                <span
                  style={{ cursor: 'pointer', color: '#1890ff' }}
                  onClick={() => form.setFieldsValue({ members: [] })}
                >
                  Clear all
                </span>
              </div>
              {menu}
            </>
          )}
          options={[...users]
            .map((u) => ({
              value: u._id,
              label: timeTrackerAssignableUserLabel(u),
            }))
            .sort((a, b) =>
              (a.label || '').localeCompare(b.label || '', undefined, {
                sensitivity: 'base',
              }),
            )}
        />
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Space>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            {id ? 'Update' : 'Create'}
          </Button>
          <Button onClick={() => history.push('/time-tracker/user-groups')}>
            Cancel
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
